/*
 * Copyright 2026 Oddpods
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 *
 * See https://github.com/oddpods/cauce/blob/main/LICENSE
 */
package studio.oddpods.cauce.core.data.repositoryImpl.cauce

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import studio.oddpods.cauce.core.model.profile.OnboardingStep
import studio.oddpods.cauce.core.model.profile.Profile
import studio.oddpods.cauce.core.model.reminder.DEFAULT_REMINDER_TEMPLATE

@Serializable
internal data class ProfileDto(
    val id: String,
    @SerialName("display_name") val displayName: String? = null,
    val tier: String = "free",
    @SerialName("default_session_fee") val defaultSessionFee: Long? = null,
    @SerialName("onboarding_step") val onboardingStep: String = "pain_id",
    @SerialName("onboarding_completed") val onboardingCompleted: Boolean = false,
    @SerialName("reminder_schedule_days") val reminderScheduleDays: List<Int> = listOf(3, 7, 14),
    @SerialName("max_reminders") val maxReminders: Int = 3,
    @SerialName("reminder_template") val reminderTemplate: String = DEFAULT_REMINDER_TEMPLATE,
)

internal fun ProfileDto.toDomain(): Profile = Profile(
    id = id,
    displayName = displayName,
    tier = tier,
    defaultSessionFee = defaultSessionFee,
    onboardingStep = OnboardingStep.fromSerialName(onboardingStep) ?: OnboardingStep.PAIN_ID,
    onboardingCompleted = onboardingCompleted,
    reminderScheduleDays = reminderScheduleDays,
    maxReminders = maxReminders,
    reminderTemplate = reminderTemplate,
)
